import { NavLink, Route, Routes, Link } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { Techniques } from './pages/Techniques';
import { Docs } from './pages/Docs';
import { Compare } from './pages/Compare';

const NAV = [
  { to: '/', label: 'Scan' },
  { to: '/techniques', label: 'Techniques' },
  { to: '/docs', label: 'Docs' },
  { to: '/compare', label: 'Compare' },
];

function NavItem({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) =>
        `text-sm transition-colors ${
          isActive ? 'text-primary' : 'text-secondary hover:text-primary'
        }`
      }
    >
      {label}
    </NavLink>
  );
}

export function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-50 border-b border-border bg-surface/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
          <Link to="/" className="flex min-w-0 items-center gap-2.5">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-strong bg-card text-primary">
              <FingerprintIcon />
            </span>
            <span className="truncate text-xs font-semibold uppercase tracking-[0.2em] text-primary sm:text-sm">
              Fingerprint Lab
            </span>
          </Link>
          <nav className="flex shrink-0 items-center gap-4 sm:gap-5">
            {NAV.map((n) => (
              <NavItem key={n.to} {...n} />
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 sm:px-6 sm:py-8 md:py-10">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/techniques" element={<Techniques />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="border-t border-border py-6">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 text-sm text-secondary sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <span>
            Browser fingerprinting, bot detection, and an honest coverage catalog. Research and
            educational use.
          </span>
          <nav className="flex shrink-0 items-center gap-4">
            <Link to="/techniques" className="text-secondary hover:text-primary">
              Techniques
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

function FingerprintIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M12 11a5 5 0 0 1 0 10" />
        <path d="M16 8a9 9 0 0 1 0 16" />
        <path d="M20 5a13 13 0 0 1 0 22" />
      </g>
      <circle cx="16" cy="16" r="2" fill="currentColor" />
    </svg>
  );
}

function NotFound() {
  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-semibold text-primary">Page not found</h1>
      <p className="text-sm text-secondary">
        Try the <Link to="/" className="text-accent underline underline-offset-4">scanner</Link>.
      </p>
    </div>
  );
}
